/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingstepprofile2Inputs */

const en_onboardingstepprofile2 = /** @type {(inputs: Onboardingstepprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const de_onboardingstepprofile2 = /** @type {(inputs: Onboardingstepprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Onboardingstepprofile2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingstepprofile2 = /** @type {((inputs?: Onboardingstepprofile2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingstepprofile2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingstepprofile2(inputs)
	return de_onboardingstepprofile2(inputs)
});
export { onboardingstepprofile2 as "onboardingStepProfile" }